import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles';
import styled from 'styled-components';
import { useSelector, useDispatch } from 'react-redux';
import { showConfirmationWin, showTostLoader } from '../../slices/customQueryHeaderSlice';
const DialogButton = withStyles({
  root: {
    background: '#005099',
    padding: '7px 32px'
  },
  label: {
    border: 'none',
    fontSize: 13,
    color: '#fff !important',
    fontFamily: '"OpenSans-Regular" !important',
    fontWeight: 500
  }
})(Button);
export const StyledDialogContent = styled(DialogContent)`
  cursor: move;
  color: #292928 !important;
  font-family: 'OpenSans-Regular' !important;
  font-size: 13px !important;
`;
export const StyledDialogTitle = styled(DialogTitle)`
  cursor: move;
  color: #292928 !important;
  font-family: 'OpenSans-Regular' !important;
  font-size: 13px !important;
`;
export const StyledDialogContentText = styled(DialogContentText)`
  height: 15px;
  width: 221px;
  color: rgba(0, 0, 0, 0.85) !important;
  font-family: 'OpenSans-Light' !important;
  font-size: 13px !important;
  font-weight: 500 !important;
  letter-spacing: 0;
  line-height: 15px !important;
`;
export default function ConfirmationModal(props) {
  const {
    processDelete
  } = props;
  const dispatch = useDispatch();
  const showConfirmationWindow = useSelector(state => state.customQueryHeader.showConfirmationWin);

  const handleDeleteQuery = () => {
    processDelete();
    dispatch(showConfirmationWin(false));
    dispatch(showTostLoader(true));
  };

  const handleClose = () => {
    dispatch(showConfirmationWin(false));
  };

  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Dialog, {
    open: showConfirmationWindow,
    onClose: handleClose,
    "aria-labelledby": "draggable-dialog-title"
  }, /*#__PURE__*/React.createElement(StyledDialogTitle, {
    id: "draggable-dialog-title"
  }, "Confirmation"), /*#__PURE__*/React.createElement(StyledDialogContent, null, /*#__PURE__*/React.createElement(StyledDialogContentText, null, "Are you sure to delete the record?")), /*#__PURE__*/React.createElement(DialogActions, null, /*#__PURE__*/React.createElement(Button, {
    variant: "outlined",
    color: "primary",
    onClick: handleClose
  }, "Cancel"), /*#__PURE__*/React.createElement(DialogButton, {
    variant: "contained",
    onClick: handleDeleteQuery,
    color: "primary"
  }, "OK"))));
}